export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -10.56324782.png";